<template>
    <div class="login" style="padding-top: 0">
        <b-container>
            <b-row class="justify-content-center items-center">

                <b-col cols="12" md="4" class="bg-white p-0">
                    <img src="../assets/images/login.png" alt="login" class="mw-100 h-100">
                </b-col>

                <b-col cols="12" md="4" class="bg-white p-3">
                    <div class="p-8 login-tabs-container">

                        <div class="mb-3">
                            <h4 class="mb-1">Login</h4>
                            <p>Welcome back, please login to your account.</p>
                        </div>

                        <div>
                            <b-form-input
                                type="text"
                                name="login"
                                placeholder="Login"
                                v-model="loginForm.login"
                                class=" mb-3"></b-form-input>
                            <span class="text-danger text-sm" style="display: none"></span>
                            <b-form-input
                                type="password"
                                name="password"
                                placeholder="Password"
                                v-model="loginForm.password"
                                class="mb-3" @keyup.enter="login"></b-form-input>
                            <span style="display: none"></span>
                            <div class=" text-center mb-2">
                                <b-button variant="success" @click="signIn">Login</b-button>
                            </div>
                        </div>

                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import $ from 'jQuery';
    import { mapMutations } from 'vuex';
    import router from "vue-bootstrap-typeahead/src/router";

    export default {
        name: "loginTest",
        data() {
            return {
                loginForm: {
                    login: "",
                    password: "",
                    type:"2"
                },
                api:"https://gamejava.monkeytree.com.hk/vue/vueLogin?",
            }
        },
        created() {
           this.getUser();


        },
        methods: {
            ...mapMutations(['changeLogin']),
            getUser() {
                // localStorage.setItem('token','87b1d1ee-e6c1-4c59-b391-077802bb49f4')
                var that = this;
                that.$axios.get("https://gamejava.monkeytree.com.hk/vue/getUser?" + "token=" + localStorage.getItem("token"),{
                    withCredentials: true
                }).then(function (resp){
                    // console.log(resp.data.success)
                    if(resp.data.success === "true"){
                        localStorage.setItem('token', resp.data.token);
                        that.$router.push({path: '/home'});
                    }
                })
            },
            signIn() {
                // this.$router.push({path: '/home'});
                console.log(this.loginForm);
                let userForm = this.loginForm;
                let loader = this.$loading.show({});
                let _this = this;
                if (this.loginForm.login === '' || this.loginForm.password === '') {
                    alert('Account and password cannot be empty');
                    loader.hide();
                } else {
                    this.$axios({
                        method: 'post',
                        url: this.api + "login=" + userForm.login + "&" +
                            "password=" + userForm.password + "&" +
                            "type="+ userForm.type
                        // data: userForm,
                    }).then(res => {
                        console.log(res.data.success);
                        if (res.data.success === "true") {
                            // localStorage.setItem('token', res.data['x-auth-token']);
                            // localStorage.setItem('uid', res.data['uid']);
                            localStorage.setItem('token', res.data.token);
                            localStorage.setItem('isToken',res.data.success);
                            this.$router.push({path: '/home'});
                            // console.log("登录成功！")
                            // _this.$router.push({path: '/case'});
                        } else {
                            alert('user name or password is error !');
                        }
                        loader.hide();
                    }).catch(error => {
                        console.log(error);
                        loader.hide();
                    })
                }
            },


            //     let userForm = this.loginForm;
            //     let loader = this.$loading.show({});
            //     let _this = this;
            //     if (this.loginForm.login === '' || this.loginForm.password === '') {
            //         alert('Account and password cannot be empty');
            //         loader.hide();
            //     } else {
            //         this.$axios({
            //             method: 'post',
            //             url: this.GLOBAL.rootPath + '/user/signIn',
            //             data: userForm,
            //         }).then(res => {
            //             if (res.data.success) {
            //                 localStorage.setItem('token', res.data['x-auth-token']);
            //                 localStorage.setItem('uid', res.data['uid']);
            //                 _this.$router.push({path: '/case'});
            //                 this.$router.push({path: '/home'});
            //             } else {
            //                 alert('user name or password is error !');
            //             }
            //             loader.hide();
            //         }).catch(error => {
            //             console.log(error);
            //             loader.hide();
            //         })
            //     }
            // },
        },
        // mounted() {
        //     AppOptions.appWithoutSidebar = true;
        //     AppOptions.appWithoutHeader = true;
        //     AppOptions.appContentFullWidth = true;
        // },
        // beforeRouteLeave(to, from, next) {
        //     AppOptions.appWithoutSidebar = false;
        //     AppOptions.appWithoutHeader = false;
        //     AppOptions.appContentFullWidth = false;
        //     next();
        // },
    }
</script>

<style scoped>

</style>
